import { ValidationErrors, AbstractControl, ValidatorFn } from '@angular/forms';
import { StringUtility } from '../utility/string.utility';

export function EmailListValidator(
	maxLength: number,
	pattern: RegExp
): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if (control.value) {
			const parts: string[] = StringUtility.trimmedCommaSeparatedValues(
				control.value
			);
			const invalidParts = [];
			parts.forEach((part) => {
				if (part.length > maxLength || !pattern.test(part)) {
					invalidParts.push(part);
				}
			});
			if (invalidParts.length > 0) {
				return {
					emailList: {
						value: control.value,
						invalidParts: invalidParts,
						message: `Invalid email address${
							invalidParts.length > 1 ? 'es' : ''
						}: ${invalidParts.join(', ')}`,
					},
				};
			}
		}
		return null;
	};
}
